import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  notification,
  Row,
  Select,
  Switch,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COURIER_TYPE, STATUS } from '../../../helpers/constants';
import { getSlotTemplates } from '../../../store/requests/slot';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import moment from 'moment';
import {
  getV2Regions,
  getV2Stores,
  getV2Zones,
} from '../../../store/requests/definitions';
import DebounceSelect from '../../DebounceSelect';

const { Option } = Select;

const SelectRegionsAndStoresZone = ({
  setFilterTemplateZonePayload,
  setSelectedRows,
  setSelectedRowKeys,
  setSlotTemplatesData,
  loading,
  setSelectListOrCalendar,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [stores, setStores] = useState([]);
  const [regions, setRegions] = useState([]);
  const [zones, setZones] = useState([]);
  const [slotTemplates, setSlotTemplates] = useState([]);
  const [isLoadingZones, setIsLoadingZones] = useState(false);
  const [searchByFilterTheZone, setSearchByFilterTheZone] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState([]);

  const onFinish = async (values) => {
    const [startDate, endDate] = values.startAndEndDate;
    const { startAndEndDate, selectRegion, selectStore, ...payload } = values;

    const unixStartDate =
      startDate.utc().hour(0).minute(0).second(0).millisecond(0).unix() * 1000;
    const unixEndDate =
      endDate.utc().hour(0).minute(0).second(0).millisecond(0).unix() * 1000;
    const zoneIds = payload?.zoneIds?.map((zone) =>
      zone.value ? zone.value : zone,
    );

    const requestPayload = {
      ...payload,
      zoneIds,
      startDate: unixStartDate,
      endDate: unixEndDate,
    };
    setFilterTemplateZonePayload(requestPayload);
  };

  useEffect(() => {
    getV2Regions(`?size=20000`).then((res) => {
      setRegions(res?.content);
    });
    getSlotTemplates(`&size=2000`).then((res) => {
      setSlotTemplates(res.content);
    });
  }, []);

  const handleChangeRegion = async (selected, options) => {
    form.resetFields(['selectStore', 'zoneIds']);
    setStores([]);
    setZones([]);
    setSelectedRegion(selected);
    if (selected.length > 0) {
      getV2Stores(`?filter=region.id=in=(${selected})&size=20000`).then(
        (res) => {
          setStores(res?.content);
        },
      );
    }
  };

  const handleChangeStore = (selected) => {
    setIsLoadingZones(true);
    form.resetFields(['zoneIds']);
    setZones([]);
    if (selected.length > 0) {
      getZonesByStoreIDs(selected);
    }
  };

  const getZonesByStoreIDs = (selected) => {
    getV2Zones(`?filter=store.id=in=(${selected})&size=20000`)
      .then((res) => {
        setZones(res?.content);
        setIsLoadingZones(false);
      })
      .finally(() => {
        setIsLoadingZones(false);
      });
  };

  const getZonesByWords = (value) => {
    return getV2Zones(
      `?filter=(name=like='${value}' or code=like='${value}') and active==true&size=2000`,
    ).then((res) =>
      res?.content.length > 0
        ? res?.content?.map((store) => ({
            label: `${store.code}-${store.name}`,
            value: store.id,
          }))
        : [],
    );
  };

  const showNotificationMessage = (type) => {
    notification[type]({
      message: t('reqSlotTemplateOrZone'),
    });
  };

  return (
    <Card
      title={t('slotTemplateZoneListPage')}
      actions={[
        <Button onClick={() => form.submit()} loading={loading} type="primary">
          {t('list')}
        </Button>,
      ]}
      extra={
        <div>
          {t('searchByZoneOrSlotTemplateOnly')}{' '}
          <Switch
            defaultChecked={searchByFilterTheZone}
            checked={searchByFilterTheZone}
            onChange={(e) => {
              setSearchByFilterTheZone(e);
              form.resetFields(['zoneIds']);
            }}
          >
            dasd
          </Switch>
          <Button
            danger
            onClick={() => {
              form.resetFields();
              setSelectedRows([]);
              setSelectedRowKeys([]);
              setSlotTemplatesData([]);
              setSelectListOrCalendar(false);
              setSelectedRegion([]);
            }}
            type="text"
          >
            {t('clear')}
          </Button>
        </div>
      }
      style={{ width: '100%' }}
    >
      <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        initialValues={{ courierType: COURIER_TYPE.STAFF }}
        style={{ width: '100%' }}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="startAndEndDate"
              label={t('startAndEndDate')}
              labelWrap
              rules={[
                {
                  required: true,
                  message: t('required'),
                },
              ]}
              style={{ width: '100%' }}
            >
              <DatePicker.RangePicker
                placeholder={[t('validityStartDate'), t('validityEndDate')]}
                format={'DD-MM-YYYY'}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={t('template')}
              labelAlign="left"
              name="slotTemplateIds"
              labelWrap
              style={{ width: '100%' }}
            >
              <Select
                autoClearSearchValue={false}
                showSearch
                mode="multiple"
                optionFilterProp="children"
                maxTagCount={1}
                placeholder={t('template')}
                filterOption={(input, option) =>
                  (option?.children ?? '')
                    .toLocaleLowerCase('tr-TR')
                    .includes(input.toLocaleLowerCase('tr-TR'))
                }
                style={{ width: '100%' }}
              >
                {slotTemplates &&
                  slotTemplates.map((slot) => (
                    <Option key={slot.id} value={slot.id}>
                      {slot.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={t('active')}
              labelAlign="left"
              name="active"
              initialValue={true}
              valuePropName="checked"
              labelWrap
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            </Form.Item>
          </Col>
        </Row>
        {!searchByFilterTheZone && (
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label={t('selectRegion')}
                labelAlign="left"
                name="selectRegion"
                labelWrap
                style={{ width: '100%' }}
              >
                <Select
                  autoClearSearchValue={false}
                  showSearch
                  mode="multiple"
                  placeholder={t('selectRegion')}
                  optionFilterProp="children"
                  onChange={handleChangeRegion}
                  maxTagCount={1}
                  filterOption={(input, option) =>
                    (option?.children ?? '')
                      .toLocaleLowerCase('tr-TR')
                      .includes(input.toLocaleLowerCase('tr-TR'))
                  }
                  style={{ width: '100%' }}
                >
                  {regions.length > 0 &&
                    regions.map((region) => (
                      <Option key={region.id} value={region.id}>
                        {region.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={t('selectStore')}
                labelAlign="left"
                name="selectStore"
                labelWrap
                style={{ width: '100%' }}
                rules={[
                  {
                    required: selectedRegion.length > 0,
                    message: t('required'),
                  },
                ]}
              >
                <Select
                  autoClearSearchValue={false}
                  showSearch
                  mode="multiple"
                  optionFilterProp="children"
                  placeholder={t('selectStore')}
                  onChange={handleChangeStore}
                  disabled={!stores.length}
                  maxTagCount={1}
                  filterOption={(input, option) =>
                    (option?.children ?? '')
                      .toLocaleLowerCase('tr-TR')
                      .includes(input.toLocaleLowerCase('tr-TR'))
                  }
                  style={{ width: '100%' }}
                >
                  {stores.length > 0 &&
                    stores.map((store) => (
                      <Option
                        key={store.id}
                        value={store.id}
                      >{`${store.code}-${store.name}`}</Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={t('zone')}
                labelAlign="left"
                name="zoneIds"
                labelWrap
                style={{ width: '100%' }}
                rules={[
                  {
                    required: selectedRegion.length > 0,
                    message: t('required'),
                  },
                ]}
              >
                <Select
                  autoClearSearchValue={false}
                  showSearch
                  mode="multiple"
                  loading={isLoadingZones}
                  allowClear
                  placeholder={t('selectZone')}
                  disabled={!zones.length}
                  maxTagCount={2}
                  filterOption={(input, option) =>
                    (option?.children ?? '')
                      .toLocaleLowerCase('tr-TR')
                      .includes(input.toLocaleLowerCase('tr-TR'))
                  }
                  style={{ width: '100%' }}
                >
                  {zones.length > 0 &&
                    zones?.map((zone) => (
                      <Option
                        key={zone.id}
                        value={zone.id}
                      >{`${zone.code}-${zone.name}`}</Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}
        {searchByFilterTheZone && (
          <Row>
            <Col span={10}>
              <Form.Item
                label={t('zone')}
                labelAlign="left"
                name="zoneIds"
                labelWrap
                style={{ width: '100%' }}
              >
                <DebounceSelect
                  mode="multiple"
                  placeholder={t('enterAFewLettersForZoneSearch')}
                  fetchOptions={getZonesByWords}
                  maxTagCount={3}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </Card>
  );
};

export default SelectRegionsAndStoresZone;
